module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-slide-in-right/wow-slide-in-right.component.scss
// module id = ./src/app/features/wow-slider/wow-slide-in-right/wow-slide-in-right.component.scss
// module chunks = main